module.exports = __webpack_public_path__ + "img/hqms.b544b86e.png";